import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["name", "disabled", "onClick", "data-qa"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_field = _resolveComponent("field")

  return (_openBlock(), _createBlock(_component_field, _mergeProps(_ctx.$attrs, {
    name: _ctx.name,
    "read-only": _ctx.readOnly,
    class: "gfu-selector-btn__wrapper"
  }), {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, (value, key, index) => {
        return (_openBlock(), _createElementBlock("button", {
          key: value,
          name: _ctx.name,
          type: "button",
          class: _normalizeClass(['gfu-selector-btn gfu-selector-btn--multi', { 'gfu-selector-btn--transparent': $props.transparent, 'gfu-selector-btn--first': $options.isFirstOption(index),
                                                                       'gfu-selector-btn--middle': $options.isMiddleOption(index), 'gfu-selector-btn--last': $options.isLastOption(index), 'gfu-selector-btn--active gfu-selector-btn--nofx': _ctx.model === value, 'gfu-selector-btn--light': $props.light }]),
          disabled: _ctx.readOnly,
          onClick: $event => ($options.selectOption(value)),
          "data-qa": `multi-selector-field:${key}`
        }, _toDisplayString(key), 11 /* TEXT, CLASS, PROPS */, _hoisted_1))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _: 1 /* STABLE */
  }, 16 /* FULL_PROPS */, ["name", "read-only"]))
}